const emptyFilesState = {
  isUploading: false,
  isLoadingFileTypes: false,
  isLoadingFileTags: false,
  uploadProcess: null,
  uploadProcessFetchDetails: null,
  currentBpFiles: [],
  bpFilesList: [],
  fileTypes: [],
  fileTags: [],
  multiUploadFiles: [],
  recommendedFileTypes: [],
  recommendedFileTypesMessage: null,
  recentFiles: [],
  // Lazy loading tracking
  loadedFolders: new Set(),
  loadedCategories: new Set(),
  loadedCustomFolders: new Set(),
  allFilesLoaded: false,
  // Loading states
  loadingFolders: new Set(),
  loadingCategories: new Set(),
  loadingCustomFolders: new Set(),
  isLoadingAllFiles: false,
  isLoadingBpFiles: false,
  // File counts (metadata without loading files)
  filesCounts: null,
  mutationVersion: 0,
  // File statistics (info panel)
  fileStatistics: null,
  fileStatisticsLoading: false,
  // Custom folder files mapping (folderId -> files array)
  customFolderFiles: {},
  // Thumbnails stored separately to avoid re-rendering file lists
  // { [fileId]: thumbnailUrl }
  thumbnailsById: {},
  // Loading progress tracking { [key]: { loaded: number } }
  loadingProgress: {},
  cursorByKey: {},
  hasMoreByKey: {}
}

export default emptyFilesState
